import {
	MenuItem,
	Radio,
	Stack,
	Switch,
	Text,
	ThemeColorVariable,
	ThemeFontSizeVariable,
	ThemeFontVariable,
} from "@caspeco/casper-ui-library";

interface IFilterSettingsRowProps {
	name: string;
	isChecked: boolean;
	setFunction: () => void;
	"data-testid"?: string;
}

interface IFilterSettingsRowRadioProps {
	name: string;
	value: string;
}
export const FilterSettingsRowSwitch = (props: IFilterSettingsRowProps) => {
	const { name, isChecked, setFunction } = props;
	return (
		<MenuItem value={name} itemType="switch">
			<Stack justifyContent={"space-between"} direction="row" w="100%">
				<Text
					color={ThemeColorVariable.OnBackground}
					fontFamily={ThemeFontVariable.SubHeader}
					fontSize={ThemeFontSizeVariable.Medium}
					fontWeight="500"
				>
					{name}
				</Text>
				<Switch
					isChecked={isChecked}
					onCheckedChange={() => setFunction()}
					data-testid={props["data-testid"]}
				></Switch>
			</Stack>
		</MenuItem>
	);
};

export const FilterSettingsRowRadio = (props: IFilterSettingsRowRadioProps) => {
	const { name, value } = props;
	return (
		<MenuItem value={name} itemType="radio">
			<Stack justifyContent={"space-between"} direction="row" w="100%">
				<Text
					color={ThemeColorVariable.OnBackground}
					fontFamily={ThemeFontVariable.SubHeader}
					fontSize={ThemeFontSizeVariable.Medium}
					fontWeight="500"
				>
					{name}
				</Text>
				<Radio value={value} />
			</Stack>
		</MenuItem>
	);
};
